import type { AiPauseReason } from '@rp/contracts'

export const SHELL_COPY = {
  skipToMain: '跳到主要內容',
  mainNav: '主要導覽',
  brandMark: 'RP',
  queue: '佇列',
  queueUnread: (count: number) => `，${count} 則新訊息`,
  queueUnreadBadge: (count: number, cap: number) => (count > cap ? `${cap}+` : String(count)),
  corpus: '核准回覆',
  knowledge: '知識庫',
  usage: '用量',
  settings: '設定',
  operations: '營運狀況',
  switchTenant: '切換公司',
  theme: '外觀',
  themeNames: { system: '跟隨系統', light: '淺色', dark: '深色' },
  signOut: '登出',
  more: '更多',
  moreActions: '更多選項',
  notFoundTitle: '找不到這個頁面',
  notFoundBody: '這個網址不存在，請從佇列重新開始。',
  backToQueue: '回到佇列',
  pickItemTitle: '選擇一則項目',
  pickItemBody: '在左邊的佇列選一則，內容會在這裡打開。',
  aiPausedTitle: 'AI 已暫停',
  aiPausedDetail: '新訊息仍會照常進入佇列並通知你，但 AI 不會自動分類或草擬建議，請直接人手處理。',
  aiPausedReasons: {
    credentials_missing: '尚未設定 AI 供應商金鑰，管理員可到「設定 → AI 供應商」填入。',
    budget_exhausted: '本月的 AI 用量已達上限，管理員可在「用量」調整。',
  } satisfies Record<AiPauseReason, string>,
  aiPausedOpenSettings: '前往設定 AI 供應商',
} as const
